var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24,
    rx: 24,
    ry: 24,
    fill: "#6D7784"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7516 32.5469C15.1386 32.5469 14.6062 32.3168 14.1544 31.8566C13.7025 31.3964 13.4766 30.8681 13.4766 30.2719V17.7219C13.4766 17.1187 13.7025 16.5846 14.1544 16.1195C14.6062 15.6544 15.1386 15.4219 15.7516 15.4219H32.2516C32.8714 15.4219 33.4096 15.6544 33.8664 16.1195C34.3232 16.5846 34.5516 17.1187 34.5516 17.7219V30.2719C34.5516 30.8681 34.3232 31.3964 33.8664 31.8566C33.4096 32.3168 32.8714 32.5469 32.2516 32.5469H15.7516ZM24.0016 25.1719L32.2516 19.5969V17.7219L24.0016 23.1719L15.7516 17.7219V19.5969L24.0016 25.1719Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e32380cc2db5f7fd6d90dd0c67ef2ccb.svg";
export { ForwardRef as ReactComponent };